/**
 * Volume Price Trend (VPT)
 *
 * Cumulative volume indicator weighted by percentage price change.
 * VPT = VPT_prev + Volume × (Close − PrevClose) / PrevClose
 *
 * Category: Volume | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const vptIndicator: IndicatorDefinition = {
  id: "vpt",
  name: "Volume Price Trend",
  shortName: "VPT",
  category: "volume",
  pane: "separate",
  params: [
    { key: "color", label: "Color", type: "color", default: "#FF9800" },
  ],
  plots: [
    { key: "vpt", label: "VPT", color: "#FF9800", style: "line", lineWidth: 2, priceScaleId: "vpt" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const data: { time: number; value: number }[] = [];
    let vpt = 0;

    data.push({ time: candles[0].time, value: 0 });
    for (let i = 1; i < candles.length; i++) {
      const pctChange = candles[i - 1].close !== 0
        ? (candles[i].close - candles[i - 1].close) / candles[i - 1].close : 0;
      vpt += (candles[i].volume || 0) * pctChange;
      data.push({ time: candles[i].time, value: vpt });
    }

    return [{ key: "vpt", data }];
  },
};
